"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _AppStore = _interopRequireDefault(require("../Store/AppStore"));

var _reactRouterDom = require("react-router-dom");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * File: ReceiptPage.js
 * Project: tsys-online-payments
 *
 * Created by Jed Dumire on 08/05/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: 550,
      padding: theme.spacing(2)
    },
    gridCardContainer: {
      padding: theme.spacing(1, 3)
    },
    gridCardText: {
      flexGrow: 1
    },
    gridCardButton: {
      margin: "auto"
    },
    submitButton: {
      margin: theme.spacing(2, 2)
    },
    errorBackground: {
      backgroundColor: theme.palette.error.main
    },
    errorText: {
      color: theme.palette.error.contrastText
    },
    progressDialog: {
      padding: theme.spacing(3, 0)
    }
  };
});

var ReceiptPage = function ReceiptPage() {
  var classes = useStyles();
  var history = (0, _reactRouterDom.useHistory)();

  if (!_AppStore.default.receiptInfo) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: "/summary"
    });
  }

  var startOver = function startOver() {
    _AppStore.default.reload();

    history.push("/");
  };

  var handleNavigation = function handleNavigation(location, action) {
    //Only prompt user when they try going back
    if (action === "POP") {
      return "Warning! Your payment has already been processed.\n\nAre you sure you want to go back to the summary screen? This could result in submitting a duplicate payment.";
    } else {
      return true;
    }
  };

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "column",
    className: classes.root + " print-hide"
  }, _AppStore.default.receiptInfo.walletMessage && /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: true,
    fullWidth: true,
    maxWidth: "sm"
  }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, null, "Unable to Save Card on File"), /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, _AppStore.default.receiptInfo.walletMessage)), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    autoFocus: true,
    onClick: function onClick() {
      return _AppStore.default.receiptInfo.clearMessage();
    },
    color: "primary"
  }, "Ok"))), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Prompt, {
    message: handleNavigation
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "print-display"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, _AppStore.default.receiptInfo.officeName), _AppStore.default.receiptInfo.officeAddress && /*#__PURE__*/_react.default.createElement(_core.Typography, null, _AppStore.default.receiptInfo.officeAddress)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, "APPROVED")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5"
  }, "$", _AppStore.default.receiptInfo.authorizedAmount.toFixed(2))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, _AppStore.default.selectedPaymentMethod.displayName), /*#__PURE__*/_react.default.createElement(_core.Typography, null, _AppStore.default.receiptInfo.dateString)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption"
  }, "AUTH# ", _AppStore.default.receiptInfo.authCode), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption"
  }, "TRANS# ", _AppStore.default.receiptInfo.transactionLogId))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    className: classes.submitButton,
    fullWidth: true,
    onClick: function onClick() {
      return window.print();
    }
  }, "Print / Download Receipt")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "outlined",
    color: "primary",
    className: classes.submitButton,
    fullWidth: true,
    onClick: startOver
  }, "Start a new payment")));
};

var _default = (0, _mobxReact.observer)(ReceiptPage);

exports.default = _default;